<h1 mat-dialog-title>{{title}}</h1>
@if (beforeFormHtml) {
  <div mat-dialog-content beforeFields>
    <div [innerHtml]="beforeFormHtml | raw"></div>
    <br/><br/>
  </div>
}

@if (beforeComponent) {
  <div mat-dialog-content>
    <ng-container #beforeComponentContainer></ng-container>
    <br/><br/>
  </div>
}

<nuso-form-view mat-dialog-content
  [formDef]="formDef"
  [form]="form"
  [input]="input"
  [busyMessage]="busyMessage"
  [errorMessage]="errorMessage"
  [saveText]="saveText"
  [cancelText]="cancelText"
  [enableSubmit]="enableSubmit"
  [allowCancel]="allowCancel"
  [hideButtons]="hideButtons"
  (submitted)="onSave($event)"
  (cancelled)="onCancel()"
  (formInit)="onFormInit($event)"
  >
  @if (afterFormHtml) {
    <div afterFields>
      <br/>
      <div [innerHtml]="afterFormHtml | raw"></div>
    </div>
  }

  @if (afterComponent) {
    <div afterFields>
      <br/>
      <ng-container #afterComponentContainer></ng-container>
    </div>
  }
</nuso-form-view>
